module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.afd84ff.eot";